/**
 * A screen width could suffice, but to match the most appropriate video source we want to keep
 * a few things in mind.
 *
 * When the user is on a slow connection we want a video that is slightly smaller (if available)
 * and if using a retina/high resolution screen we want a slightly larger video.
 *
 * @return {Number}
 */
import isSlowConnection from '../isSlowConnection';
import isRetina from '../isRetina';

export default () => {
  if (isSlowConnection()) {
    return window.innerWidth * 0.75;
  }

  if (isRetina()) {
    return window.innerWidth * 1.5;
  }

  return window.innerWidth;
};
